import type {CreateCustomerPayload} from "@mytour/shared";

export function toCreateCustomerPayload(
  customer: Partial<CreateCustomerPayload>
): CreateCustomerPayload {
  return {
    ...toEditableCustomerPayload(customer),
    serviceAddress: customer.serviceAddress as string,
    serviceCity: customer.serviceCity as string,
    serviceZip: customer.serviceZip as string,
  };
}

export function toEditableCustomerPayload(
  customer: Partial<CreateCustomerPayload>
): Partial<CreateCustomerPayload> {
  return {
    gender: customer.gender,
    firstName: customer.firstName,
    familyName: customer.familyName,
    companyLegalName: customer.companyLegalName,
    siret: customer.siret,
    phone: customer.phone,
    email: customer.email,
    facebook: customer.facebook,
    address: customer.address,
    address2: customer.address2,
    city: customer.city,
    zip: customer.zip,
    country: customer.country,
    serviceAddress: customer.serviceAddress,
    serviceAddress2: customer.serviceAddress2,
    serviceCity: customer.serviceCity,
    serviceZip: customer.serviceZip,
    serviceLat: customer.serviceLat,
    serviceLong: customer.serviceLong,
    serviceGeocodeSource: customer.serviceGeocodeSource,
    serviceAddressChanges: customer.serviceAddressChanges,
    serviceTargets:
      customer.serviceTargets === null
        ? null
        : customer.serviceTargets?.map((target) => ({
            id: target.id,
            label: target.label,
            index: target.index,
            type: target.type,
            gender: target.gender,
            race: target.race,
            robe: target.robe,
            height: target.height,
            weight: target.weight,
            birthDate: target.birthDate,
          })),
  };
}
